import(/* webpackMode: "eager", webpackExports: ["AppNavbar"] */ "/vercel/path0/components/app-navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppSidebar"] */ "/vercel/path0/components/app-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider","SidebarInset"] */ "/vercel/path0/components/ui/sidebar.tsx");
